export default __webpack_public_path__ + "static/media/facebook.9331397a.svg";